module.exports = __webpack_public_path__ + "img/DHL-black.35cb8d2a.png";